/**
 * Returns the data of apollo
 *
 * @param response
 * @returns {*}
 */
export const formatData = (response = {}) => {
  const dataClone = { ...response.data }

  delete dataClone.loading
  delete dataClone.networkStatus
  delete dataClone.stale

  const newData = dataClone[Object.keys(dataClone)[0]]

  if ('edges' in newData) {
    const data = newData.edges.map((edge) => {
      const newNode = { ...edge.node }
      delete newNode.__typename

      return newNode
    })

    return { data }
  }

  return { data: newData }
}

/**
 * Formats errors from GraphQL API.
 *
 * @param responseErrors
 * @returns {*[]|*}
 */
export const formatErrors = (responseErrors) => {
  if (!responseErrors) {
    return []
  }

  return responseErrors.map((error) => {
    const messageArr = error.message.replace(' ', '').split(':')
    if (messageArr.length === 2) {
      return {
        message: `Error.${messageArr[1]}`,
        label: `Label.${messageArr[0]}`
      }
    }

    return null
  })
}
